import React from "react";
import { Link } from "react-router-dom";
import { ShoppingBag, User } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { useCart } from "../lib/cart";
import { useAuth } from "../lib/auth";

export function LanguageToggle({ inverse }) {
  const { lang, setLang } = useI18n();
  return (
    <div
      data-testid="language-selector"
      className={`flex items-center rounded-full p-[3px] ${inverse ? "bg-black/40" : "bg-hm-tertiary"}`}
    >
      {["fr", "de"].map((l) => {
        const on = lang === l;
        return (
          <button
            key={l}
            type="button"
            data-testid={`lang-${l}`}
            onClick={() => setLang(l)}
            className={`h-[30px] rounded-full px-3 font-sans text-xs font-extrabold transition-colors ${
              on ? "bg-hm-inverse text-white" : inverse ? "text-white/80" : "text-hm-muted"
            }`}
          >
            {l.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
}

export function Header() {
  const { count } = useCart();
  const { user } = useAuth();
  return (
    <header className="sticky top-0 z-30 border-b border-hm-line bg-hm-surface/95 backdrop-blur-md">
      <div className="mx-auto flex h-14 w-full max-w-[1120px] items-center justify-between px-4">
        <Link to="/" className="flex items-center gap-2.5" data-testid="home-title">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-hm-brand font-display text-xl text-white">H</span>
          <span className="font-display text-xl text-hm-ink">Hallo Magic Pizza</span>
        </Link>
        <div className="flex items-center gap-3">
          <LanguageToggle />
          <Link
            to="/account"
            data-testid="header-account-link"
            className="flex h-10 items-center gap-2 rounded-full bg-hm-tertiary px-3 text-hm-ink transition-colors hover:bg-hm-lineStrong"
          >
            <User size={18} />
            {user ? <span className="hidden font-sans text-sm font-bold sm:block" data-testid="header-account-name">{user.first_name}</span> : null}
          </Link>
          <Link
            to="/cart"
            data-testid="header-cart-link"
            className="relative flex h-10 w-10 items-center justify-center rounded-full bg-hm-tertiary text-hm-ink transition-colors hover:bg-hm-lineStrong"
          >
            <ShoppingBag size={18} />
            {count > 0 ? (
              <span
                data-testid="header-cart-count"
                className="absolute -right-1 -top-1 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-hm-brand px-1 font-sans text-[11px] font-extrabold text-white"
              >
                {count}
              </span>
            ) : null}
          </Link>
        </div>
      </div>
    </header>
  );
}
